import type { ColDef } from "ag-grid-enterprise";
import { mapColDefTree } from "../col_def_tree";

// Weight (and similar numeric-looking) columns are pre-formatted strings (e.g. "10.00"),
// which AG-Grid's default sort compares lexicographically ("10.00" before "2.00").
function numberComparator(valueA: unknown, valueB: unknown): number {
  const a = Number(valueA);
  const b = Number(valueB);
  if (Number.isNaN(a) && Number.isNaN(b)) return 0;
  if (Number.isNaN(a)) return -1;
  if (Number.isNaN(b)) return 1;
  return a - b;
}

// Driven by colDef.context.numericSort rather than cellDataType: 'number' — the latter's
// built-in valueFormatter renders "Invalid Number" for our pre-formatted numeric strings.
// Descends into ColGroupDef.children: the vote-by-vote scored grid carries numericSort on
// grouped leaves, and this is the load-bearing decorator for that grid.
export function withNumberComparator(columnDefs: ColDef[]): ColDef[] {
  return mapColDefTree(columnDefs, (c) =>
    (c.context as Record<string, unknown> | undefined)?.numericSort
      ? { ...c, comparator: numberComparator }
      : c
  );
}
